import { ORPCError } from "@orpc/client";
import { useRouteError } from "react-router";
import { SkillNotFound } from "./SkillNotFound.tsx";

interface SkillDetailErrorBoundaryProps {
    backHref: string;
}

export function SkillDetailErrorBoundary({ backHref }: SkillDetailErrorBoundaryProps) {
    const error = useRouteError();

    if (error instanceof ORPCError && error.code === "NOT_FOUND") {
        return <SkillNotFound backHref={backHref} />;
    }

    throw error;
}
